import { environments } from '../../environments/environment-config';
import { Environment, EnvironmentIndicator } from '../enums/environment.enum';
import { IEnvironment } from '../interfaces/environment.interface';

export class EnvironmentService {
  private static instance: EnvironmentService;
  private readonly _environmentsConfigs: IEnvironment = environments;
  private readonly _currentEnvironment: Environment;
  private readonly _currentEnvironmentConfig: IEnvironment[Environment];
  constructor() {
    this._currentEnvironment = this.getEnvironment();
    this._currentEnvironmentConfig = this._environmentsConfigs[this._currentEnvironment];
  }

  getInstance(): EnvironmentService {
    if (!EnvironmentService.instance) {
      EnvironmentService.instance = new EnvironmentService();
    }
    return EnvironmentService.instance;
  }

  get currentEnvironment(): Environment {
    return this._currentEnvironment;
  }

  get currentEnvironmentConfig(): IEnvironment[Environment] {
    return this._currentEnvironmentConfig;
  }
  
  getEnvironment(): Environment {
    const hostname = window.location.hostname;
    if (hostname.includes(EnvironmentIndicator.local)) {
      return Environment.Local;
    } else if (hostname.includes(EnvironmentIndicator.dev)) {
      return Environment.Dev;
    } else if (hostname.includes(EnvironmentIndicator.qa)) {
      return Environment.Qa;
    } else {
      return Environment.Prod;
    }
  }

}
